module.exports = __webpack_public_path__ + "media/images/icons/delete-2-5dcedb6177c83eb49e1a4bcaea06f20a.svg";